import React, { useEffect, useState } from 'react';
import FieldWithLabel from '../../../../../../Components/FieldWithLabel/FieldWithLabel';
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
} from '../../../../../../Components';
import { showError } from '../../../../../../Helper';
import { GetAllLeadExchangePoolCampaigns } from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';
import {
  commissionTypeOptions,
  entitySourcesOptions,
  envOptions,
} from '../../../Utilities/Utilities';
import { config } from '../../../../../../config';

export default function CampaignConfigurationFields({
  translate,
  parentTranslationPath,
  activeItem,
  entitySources,
  selectedValue,
  setSelectedValue,
  setState,
  campaignOverrides,
}) {
  const [campaigns, setCampaigns] = useState([]);
  const getLeadExchangePoolCampaignsDebounced = useDebouncedAction(
    async (name) => {
      try {
        const result = await GetAllLeadExchangePoolCampaigns(name);
        setCampaigns(result);
      } catch {
        showError('Failed to fetch campaigns');
      }
    }
  );

  useEffect(() => {
    if (activeItem) {
      setState((prev) => ({
        ...prev,
        campaignCommissionOverrideId: activeItem.campaignCommissionOverrideId,
        leadXchangeEntitySourceId: activeItem.leadXchangeEntitySourceId,
        commissionType: activeItem.commissionType,
        commissionValue: activeItem.commissionValue,
      }));
      setSelectedValue((prev) => ({
        ...prev,
        entitySource: activeItem,
        campaignOverrides: activeItem,
        commissionType: activeItem.commissionType,
        commissionValue: activeItem.commissionValue,
      }));
    }
  }, [activeItem]);

  return (
    <>
      <FieldWithLabel
        hideDivider
        label={translate('entity')}
        component={
          <AutocompleteComponent
            wrapperClasses={activeItem ? 'w-100' : 'w-50'}
            idRef='EntityRef'
            withoutSearchButton
            multiple={false}
            parentTranslationPath={parentTranslationPath}
            inputPlaceholder={'select'}
            inputClasses='fields-content'
            data={entitySources ?? []}
            selectedValues={selectedValue?.entitySource}
            isDisabled={activeItem}
            filterOptions={(options) =>
              options.filter((option) => {
                if (envOptions.includes(config.name)) return true;
                return entitySourcesOptions.includes(option.entitySourceName);
              })
            }
            displayLabel={(option) =>
              option?.entitySourceName ?? option?.entityName
            }
            chipsLabel={(option) =>
              option?.entitySourceName ?? option?.entityName
            }
            onChange={(_, newValue) => {
              console.log('newValue: ', newValue);
              setState((prev) => ({
                ...prev,
                leadXchangeEntitySourceId: newValue?.entitySourceId,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                entitySource: newValue,
              }));
              getLeadExchangePoolCampaignsDebounced(newValue?.entitySourceName);
            }}
          />
        }
      />
      {activeItem && <hr className='hr-divider' />}
      <FieldWithLabel
        hideDivider
        label={translate('Campaign name')}
        component={
          <AutocompleteComponent
            wrapperClasses={activeItem ? 'w-100' : 'w-50'}
            idRef='CampaignRef'
            withoutSearchButton
            multiple={false}
            parentTranslationPath={parentTranslationPath}
            isDisabled={!selectedValue?.entitySource}
            inputPlaceholder={'select'}
            inputClasses='fields-content'
            data={campaigns ?? []}
            selectedValues={selectedValue?.campaignOverrides}
            displayLabel={(option) => option?.campaignName ?? ''}
            chipsLabel={(option) => option?.campaignName ?? ''}
            onChange={(_, newValue) => {
              setState((prev) => ({
                ...prev,
                campaignName: newValue?.campaignName,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                campaignOverrides: newValue,
              }));
            }}
          />
        }
      />
      {activeItem && <hr className='hr-divider' />}
      <FieldWithLabel
        hideDivider
        label={translate('commission_type')}
        component={
          <SelectComponet
            wrapperClasses={`fields-content ${activeItem ? 'w-100' : 'w-50'}`}
            idRef='commissionRef'
            placeholder='select'
            data={commissionTypeOptions}
            valueInput='value'
            textInput='text'
            parentTranslationPath={parentTranslationPath}
            value={selectedValue?.commissionType}
            emptyItem={{
              value: null,
              text: 'Select',
              isDisabled: false,
            }}
            onSelectChanged={(newValue) => {
              setState((prev) => ({
                ...prev,
                commissionType: newValue,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                commissionType: newValue,
              }));
            }}
          />
        }
      />
      {activeItem && <hr className='hr-divider' />}
      <FieldWithLabel
        hideDivider
        label={translate('value')}
        component={
          <Inputs
            wrapperClasses={activeItem ? 'w-100' : 'w-50'}
            idRef='valueRef'
            inputPlaceholder={'enter'}
            fieldClasses='fields-content'
            onInputChanged={(e) => {
              const newValue = e.target.value;
              setState((prev) => ({
                ...prev,
                commissionValue: +newValue,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                commissionValue: +newValue,
              }));
            }}
            value={selectedValue?.commissionValue}
            parentTranslationPath={parentTranslationPath}
            isWithError
            error={
              selectedValue?.commissionType === 2 &&
              selectedValue?.commissionValue > 100
            }
            helperText={
              selectedValue?.commissionType === 2 &&
              selectedValue?.commissionValue > 100
                ? 'Please enter a valid commission value.'
                : ''
            }
            type='number'
          />
        }
      />
    </>
  );
}
